module.exports = "<div class=\"main-content\">\n  <router-outlet></router-outlet>\n</div>\n<div class=\"container\">\n<app-footer></app-footer>\n</div>"